"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWS_REGIONS_MAP = exports.AwsShortRegions = exports.AwsRegions = void 0;
var AwsRegions;
(function (AwsRegions) {
    AwsRegions["AFS1"] = "af-south-1";
    AwsRegions["APE1"] = "ap-east-1";
    AwsRegions["APNE1"] = "ap-northeast-1";
    AwsRegions["APNE2"] = "ap-northeast-2";
    AwsRegions["APS1"] = "ap-south-1";
    AwsRegions["APSE1"] = "ap-southeast-1";
    AwsRegions["APSE2"] = "ap-southeast-2";
    AwsRegions["CAC1"] = "ca-central-1";
    AwsRegions["CN1"] = "cn-north-1";
    AwsRegions["EUC1"] = "eu-central-1";
    AwsRegions["EUN1"] = "eu-north-1";
    AwsRegions["EUS1"] = "eu-south-1";
    AwsRegions["EUW1"] = "eu-west-1";
    AwsRegions["EUW2"] = "eu-west-2";
    AwsRegions["EUW3"] = "eu-west-3";
    AwsRegions["SAE1"] = "sa-east-1";
    AwsRegions["USE1"] = "us-east-1";
    AwsRegions["USE2"] = "us-east-2";
    AwsRegions["USGE1"] = "us-gov-east-1";
    AwsRegions["USGW1"] = "us-gov-west-1";
    AwsRegions["USW1"] = "us-west-1";
    AwsRegions["USW2"] = "us-west-2";
})(AwsRegions || (exports.AwsRegions = AwsRegions = {}));
var AwsShortRegions;
(function (AwsShortRegions) {
    AwsShortRegions["AFS1"] = "afs1";
    AwsShortRegions["APE1"] = "ape1";
    AwsShortRegions["APNE1"] = "apne1";
    AwsShortRegions["APNE2"] = "apne2";
    AwsShortRegions["APS1"] = "aps1";
    AwsShortRegions["APSE1"] = "apse1";
    AwsShortRegions["APSE2"] = "apse2";
    AwsShortRegions["CAC1"] = "cac1";
    AwsShortRegions["CN1"] = "cn1";
    AwsShortRegions["EUC1"] = "euc1";
    AwsShortRegions["EUN1"] = "eun1";
    AwsShortRegions["EUS1"] = "eus1";
    AwsShortRegions["EUW1"] = "euw1";
    AwsShortRegions["EUW2"] = "euw2";
    AwsShortRegions["EUW3"] = "euw3";
    AwsShortRegions["SAE1"] = "sae1";
    AwsShortRegions["USE1"] = "use1";
    AwsShortRegions["USE2"] = "use2";
    AwsShortRegions["USGE1"] = "usge1";
    AwsShortRegions["USGW1"] = "usgw1";
    AwsShortRegions["USW1"] = "usw1";
    AwsShortRegions["USW2"] = "usw2";
})(AwsShortRegions || (exports.AwsShortRegions = AwsShortRegions = {}));
exports.AWS_REGIONS_MAP = {
    [AwsShortRegions.AFS1]: AwsRegions.AFS1,
    [AwsShortRegions.APE1]: AwsRegions.APE1,
    [AwsShortRegions.APNE1]: AwsRegions.APNE1,
    [AwsShortRegions.APNE2]: AwsRegions.APNE2,
    [AwsShortRegions.APS1]: AwsRegions.APS1,
    [AwsShortRegions.APSE1]: AwsRegions.APSE1,
    [AwsShortRegions.APSE2]: AwsRegions.APSE2,
    [AwsShortRegions.CAC1]: AwsRegions.CAC1,
    [AwsShortRegions.CN1]: AwsRegions.CN1,
    [AwsShortRegions.EUC1]: AwsRegions.EUC1,
    [AwsShortRegions.EUN1]: AwsRegions.EUN1,
    [AwsShortRegions.EUS1]: AwsRegions.EUS1,
    [AwsShortRegions.EUW1]: AwsRegions.EUW1,
    [AwsShortRegions.EUW2]: AwsRegions.EUW2,
    [AwsShortRegions.EUW3]: AwsRegions.EUW3,
    [AwsShortRegions.SAE1]: AwsRegions.SAE1,
    [AwsShortRegions.USE1]: AwsRegions.USE1,
    [AwsShortRegions.USE2]: AwsRegions.USE2,
    [AwsShortRegions.USGE1]: AwsRegions.USGE1,
    [AwsShortRegions.USGW1]: AwsRegions.USGW1,
    [AwsShortRegions.USW1]: AwsRegions.USW1,
    [AwsShortRegions.USW2]: AwsRegions.USW2,
};
__exportStar(require("./generated/aws-region"), exports);
//# sourceMappingURL=aws.js.map